export default "__VITE_ASSET__DFIqoSUb__"